<div class="heatmap-container">
  @if (titulo()) {
    <div class="heatmap-header">
      <h3 class="heatmap-title">{{ titulo() }}</h3>
    </div>
  }
  <div class="heatmap-map" [style.height]="altura()">
    <app-mapa-facil-v2
      [zoom]="12"
      [style]="'osm'"
      [mapId]="nombreMap"
      (mapReady)="onMapReady($event)"
    ></app-mapa-facil-v2>
  </div>
</div>
